import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Country, Currency, Timezone } from '../models/config';
import { Observable } from 'rxjs';
import { Message } from '../models/domain';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(private httpClient: HttpClient) { }

  //COUNTRY

  public createCountry(country: Country): Observable<Message> {
    return this.httpClient.post<Message>('/api/config/country', country);
  }

  public getCountries(disabled?: boolean): Observable<Country[]> {
    return this.httpClient.get<Country[]>('/api/config/countries', { params: { ...(disabled != null && { disabled }) } });
  }

  public getCountry(id: number): Observable<Country> {
    return this.httpClient.get<Country>(`/api/config/country/${id}`);
  }

  public updateCountry(id: number, country: Country): Observable<Message> {
    return this.httpClient.put<Message>(`/api/config/country/${id}`, country);
  }

  public deleteCountry(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/config/country/${id}`);
  }

  public toggleCountryStatus(country: Country): Observable<Message> {
    return this.httpClient.put<Message>(`/api/config/country/${country.id}`, country);
  }

  //CURRENCY

  public createCurrency(currency: Currency): Observable<Message> {
    return this.httpClient.post<Message>('/api/config/currency', currency);
  }

  public getCurrencies(disabled?: boolean): Observable<Currency[]> {
    return this.httpClient.get<Currency[]>('/api/config/currencies', { params: { ...(disabled && { disabled }) } });
  }

  public getCurrency(id: number): Observable<Country> {
    return this.httpClient.get<Country>(`/api/config/currency/${id}`);
  }

  public updateCurrency(id: number, currency: Currency): Observable<Message> {
    return this.httpClient.put<Message>(`/api/config/currency/${id}`, currency);
  }

  public deleteCurrency(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/config/currency/${id}`);
  }

  public toggleCurrencyStatus(currency: Currency): Observable<Message> {
    return this.httpClient.put<Message>(`/api/config/currency/${currency.id}`, currency);
  }


  //TIMEZONE

  public createTimezone(timezone:Timezone):Observable<Message>{
    return this.httpClient.post<Message>('/api/config/timezone',timezone)
  }

  public getTimezones(disabled?: boolean): Observable<Timezone[]> {
    return this.httpClient.get<Timezone[]>('/api/config/timezones', { params: { ...(disabled && { disabled }) } });
  }

  public getTimezone(id: number): Observable<Timezone> {
    return this.httpClient.get<Timezone>(`/api/config/timezone/${id}`);
  }

  public updateTimezone(id: number, timezone: Timezone): Observable<Message> {
    return this.httpClient.put<Message>(`/api/config/timezone/${id}`, timezone);
  }

  public deleteTimezone(id: number): Observable<Message> {
    return this.httpClient.delete<Message>(`/api/config/timezone/${id}`);
  }

  public toggleTimezoneStatus(timezone: Timezone): Observable<Message> {
    return this.httpClient.put<Message>(`/api/config/timezone/${timezone.id}`, timezone);
  }
}

